// icons
import { FiLogOut, FiHome, FiGrid, FiDownload } from "react-icons/fi";
// react router dom
import { useNavigate, Link } from "react-router-dom";
// react redux
import { useDispatch } from "react-redux";
// action creators
import { logout } from "../../redux/auth";
// react
import { useEffect, useRef } from "react";
// helpers
import { clearToken } from "../../helpers/auth";

const UserMenu = ({
  closeMenu,
  userMenuButtonRef,
  className,
  openPriceList,
}) => {
  // logout handle
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutClickedHandler = () => {
    clearToken();
    dispatch(logout());
    navigate("/login");
  };

  const clickToDashBoard = () => {
    window.open("https://admin.mtor.online/");
  };

  // close the menu when cick away
  const menuRef = useRef();
  useEffect(() => {
    const clickAwayHadler = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !userMenuButtonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };

    // attach mouse down event to the DOM
    document.addEventListener("mousedown", clickAwayHadler);
    // deattach the handler when the component removed from the dom
    return () => {
      document.removeEventListener("mousedown", clickAwayHadler);
    };
  }, [closeMenu, userMenuButtonRef]);

  return (
    <nav
      dir="rtl"
      className={`absolute w-44 rounded-lg bg-indigo-50 z-10 ${className} drop-shadow-md`}
      ref={menuRef}
    >
      <ul className="py-2 space-y-2">
        <li className="hover:bg-dark-blue hover:text-white">
          <Link to="/" className="p-2 flex items-center justify-between ">
            الرئيسية
            <FiHome />
          </Link>
        </li>
        <li
          className="p-2 cursor-pointer flex items-center justify-between hover:bg-dark-blue hover:text-white"
          onClick={clickToDashBoard}
        >
          داش بورد
          <FiGrid />
        </li>
        <li
          className="p-2 cursor-pointer flex items-center justify-between hover:bg-dark-blue hover:text-white"
          onClick={() => {
            closeMenu();
            openPriceList();
          }}
        >
          تحميل قائمة الأسعار
          <FiDownload />
        </li>
        <li
          className="p-2 cursor-pointer flex items-center justify-between hover:bg-dark-blue hover:text-white"
          onClick={logoutClickedHandler}
        >
          تسجيل الخروج
          <FiLogOut />
        </li>
      </ul>
    </nav>
  );
};

export default UserMenu;
